export default class Figures {
    constructor({ el }) {
        

        const controls = el.querySelector(".toggle-play-pause")
        const soundControls = el.querySelector(".toggle-sound")
        const video =  el.querySelector("video")

        if (controls && video) {
            controls.addEventListener("click", () => {
                controls.classList.toggle("paused")
                if (controls.classList.contains("paused")) {
                    video.pause()
                } else {
                    video.play()
                }
            })
        }
        // Sound Control
        if (soundControls && video) {
            soundControls.addEventListener("click", () => {
                // Toggle the UI state class
                soundControls.classList.toggle("muted")
                
                // Check if it is currently muted based on the class
                const isMuted = soundControls.classList.contains("muted")
                
                // Apply properties to the video
                video.muted = isMuted
                
                if (!isMuted) {
                    video.volume = 1.0 // Force max volume when unmuting
                }
            })
        }

        // Inline loop videos (media block, data-autoplay) are not downloaded up
        // front: they start when they come into view and pause when they leave
        // (unless the visitor paused them with the button). Videos with the
        // autoplay attribute keep the same in/out behaviour. Hidden videos used
        // as WebGL textures have neither and must keep playing.
        const lazyAutoplay = video && video.hasAttribute("data-autoplay")
        if (video && (lazyAutoplay || (controls && video.autoplay))) {
            this.observer = new IntersectionObserver(([entry]) => {
                if (!entry.isIntersecting) {
                    video.pause()
                } else if (!controls || !controls.classList.contains("paused")) {
                    video.play().catch(() => {})
                }
            }, { threshold: 0.25, rootMargin: "200px 0px" })
            this.observer.observe(video)
        }
    }

    dispose() {
        if (this.observer) this.observer.disconnect()
    }
}